import { render } from "./EditorBody.vue?vue&type=template&id=105a21fc"
import script from "./EditorBody.vue?vue&type=script&lang=js"
export * from "./EditorBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__